import { render, staticRenderFns } from "./NewArrivalView.vue?vue&type=template&id=e1460c54&"
import script from "./NewArrivalView.vue?vue&type=script&lang=js&"
export * from "./NewArrivalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports